
import { onMounted, reactive, ref } from "vue";
import axios from "axios";
import { useRoute, useRouter } from "vue-router";
export default {
  name: "AdminOrderAdvanceEdit",
  setup() {
    const data = reactive({
      orderstatus_id: "",
      cancel_note: "",
      courier_note: "",
      rider_id: "",
    });

    const datapush = reactive({
      rider_id: "",
    });
    const router = useRouter();
    const route = useRoute();
    const orderstatuses = ref([]);
    const riders = ref([]);

    onMounted(async () => {
      const statusResponse = await axios.get("orderstatus");
      orderstatuses.value = statusResponse.data;

      const response = await axios.get(`/orders/${route.params.id}`);

      data.orderstatus_id = response.data.orderstatus.id;
      data.cancel_note = response.data.cancel_note;
      data.courier_note = response.data.courier_note;
      data.rider_id = response.data.rider_id;
      datapush.rider_id = response.data.rider_id;
      var countryid = response.data.country.id;
      if (countryid !== 1) {
        countryid = 3;
      }

      const riderResponse = await axios.get(
        `/riders/country/online/${countryid}`
      );
      riders.value = riderResponse.data;
    });

    const submit = async () => {
      await axios.put(`/orders/${route.params.id}`, data);

      await router.push("/orders");
    };

    const submitpush = async () => {
      await axios.put(`/orders/push/${route.params.id}`, datapush);

      await router.push("/orders");
    };

    return {
      data,
      orderstatuses,
      riders,
      datapush,
      submitpush,
      submit,
    };
  },
};
